import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Client } from '../../interfaces/Client.interface';
import { ScoreService } from '../../services/score.service';
import { Activity } from '../../interfaces/ScoreActivity.interface';
import { TranslateService } from '@ngx-translate/core';
import { EnceService } from '../../services/ence.service';



@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.css'],
  providers: [EnceService]
})
export class ScoreComponent implements OnInit {

  public infoClient: any;
  public activity: Array<Activity>;
  public activitySilvicola:Array<Activity>;
  public activityLudico:Array<Activity>;
  public textResponse:string;

  constructor(
    private _router: Router,
    private _scoreService: ScoreService,
    private translate: TranslateService,
    public _enceService: EnceService
    ) {
      this.activity=[];
      this.activityLudico=[];
      this.activitySilvicola=[];
   }

  ngOnInit() {

    if(localStorage.getItem('infoClient')){
      this.infoClient=JSON.parse(localStorage.getItem('infoClient'));
    }

    
    this.getActivityScore();

  }

  /**
     * Funcion que nos dice si el usuario tiene permisos de propietario para el catalogo lúdico y mas datos
     */
    public havePermissions():boolean{
      if( this.infoClient.category.id == '4' && (this.infoClient.level.id == '10' || this.infoClient.level.id == '11' || this.infoClient.level.id == '12' || this.infoClient.level.id == '13'|| this.infoClient.level.id == '14')){
        return true;
      }else{
        return false;
      }
    }

  public linkToConditions(){
    this._router.navigate(['home/conditions'])
  }

  public linkToCatalogo(){
    this._router.navigate(['home/catalogo']);
  }

  public linkToCatalogoLudico(){
    this._router.navigate(['home/catalogoludico']);
  }

  /**
   * Funcion que llama al servicio de actividad de puntos
  */
 public getActivityScore(){
   this._scoreService.getScoreActivity(this.infoClient.info.id).subscribe(
     response => {
      if(response.empty===true){
        this.textResponse= this.translate.get('ence.score-empty').toString();
      }else{
        this.formatArraysScore(response.scores);
        this.formatArraysScore(response.score);
      }
      
     },
     error => {
      console.log('Error '+JSON.stringify(error));
      
     }
   );
 }

 public formatArraysScore(scores){
   if(scores !== undefined && scores.length > 0)
   for(let item of scores){
     if(item.type == '0'){
       this.activitySilvicola.push(item);
     }else if(item.type == '1'){
       this.activityLudico.push(item);
     }
   }
 }


 /**
  * Formatea los puntos
  */
 public formatScore(score):string{
   let format;
   if(score.indexOf('-')>=0){
    format = score*100;
   }else{
    
    format = '+'+score*100;
   }
   return format;
 }
}
